var map = {
	"./Andrea McLeod-Karim.jpg": 1116,
	"./Anjan Sahu.jpg": 1117,
	"./Manohara Raj Karuppasamy.png": 1118,
	"./Michael O’Sullivan UCC.jpg": 1119,
	"./Mrs Nair.png": 1120,
	"./Nicholas Venn Springfield College.jpg": 1121,
	"./Pratik-giri.jpg": 1122,
	"./Praveen raval.57a24d7.jpg": 1123,
	"./Praveen raval.jpg": 1124,
	"./Rylan James.jpg": 1125,
	"./Shahina Khaitri.jpg": 1126,
	"./anjan.jpg": 1127,
	"./asif.png": 1128,
	"./avtar-1.png": 1129,
	"./fair-1.png": 1130,
	"./fair-2.png": 1131,
	"./fair-3.png": 1132,
	"./fair-4.png": 1133,
	"./fair-5.png": 1134,
	"./fair-6.png": 1135,
	"./img-1.png": 1136,
	"./mahonaraj.png": 1137,
	"./mehoonri.jpg": 1138,
	"./prathamesh.jpg": 1139,
	"./rylan.jpg": 1140,
	"./sandeep.jpg": 1141,
	"./seeneen mulla.jpg": 1142,
	"./shahnia.jpg": 1143,
	"./siddhi.jpg": 1144,
	"./sinjo.jpg": 1145,
	"./sonia.jpg": 1146
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 336;


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/testimonial ^\.\/.*$
// module id = 336
// module chunks = 1